<template>
    <div class="table-head head-fixed">
        <div class="table-tr">
            <div class="table-th cell-length">
                <figure></figure>
                {{ __('Patient') }}
            </div>
            <div v-if="showDaysTillEndOfSubscription" class="table-th cell-2x">
                <figure><svg-icon icon="matrix.prescription" /></figure>
                <template v-if="freemium">{{ __('Freemium will end') }}</template>
                <template v-else>{{ __('Prescription will expire') }}</template>
            </div>
            <div class="table-th cell-2x">
                <figure><svg-icon icon="matrix.login" /></figure>
                {{ __('Login') }}
            </div>
            <!--<div class="table-th cell-adherence">
                <figure><svg-icon icon="matrix.compliance" /></figure>
                {{ __('Compliance') }}
            </div>-->
            <div class="table-th">
                <figure><svg-icon icon="matrix.mood" /></figure>
                {{ __('Mood') }}
            </div>
            <div class="table-th">
                <figure><svg-icon icon="matrix.weight" /></figure>
                {{ __('Weight') }}
            </div>
            <div class="table-th">
                <figure><svg-icon icon="matrix.education" /></figure>
                {{ __('Education') }}
            </div>
            <div class="table-th">
                <figure><svg-icon icon="matrix.steps" /></figure>
                {{ __('Steps') }}
            </div>
            <div class="table-th">
                <figure><svg-icon icon="matrix.meals" /></figure>
                {{ __('[meal plan] Diet') }}
            </div>
            <div class="table-th">
                <figure><svg-icon icon="matrix.waist" /></figure>
                {{ __('Waist circumference') }}
            </div>
            <div class="table-th">
                <figure><svg-icon icon="matrix.goals" /></figure>
                {{ __('Goals') }}
            </div>
            <div class="table-th cell-call">
                <figure><svg-icon icon="matrix.call" /></figure>
                {{ __('Call') }}
            </div>
        </div>
    </div>
</template>

<script>
import TableHeader from '@components/PatientsMatrix/TableHeader'

export default {
    extends: TableHeader,
    props: {
        freemium: {
            type: Number,
            required: false,
            default: 0
        }
    },
}
</script>
